var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatLowerIncisors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 263.7 78.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:1.5px;}.cls-2{font-size:10px;fill:#4d4d4d;font-family:SegoeUI-Semibold, Segoe UI;font-weight:600;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "incisors"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cat_lower_incisors"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_403",
    "data-name": 403,
    className: "cls-1",
    d: "M31,4.82c4.6,3,5.63,8.87,6.66,19.85,1.49,16.09,2.2,24.18,0,26.54-6.54,7-24.79,4.57-31.54-5C-4.12,31.88,13.29,3.29,25.14,3A10.77,10.77,0,0,1,31,4.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_402",
    "data-name": 402,
    className: "cls-1",
    d: "M82.58,28.24c1.82,8.34,2.92,19.19-4.26,25.43C71.85,59.29,61.34,59,54,55.29c-6.13-3.12-8.94-9.14-8.14-15.94C47,29.72,54.1,6,66.72,6,74.58,5.94,80.7,19.58,82.58,28.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_401",
    "data-name": 401,
    className: "cls-1",
    d: "M126.8,30.93c2.08,8.28,3.54,19.08-3.44,25.55-6.29,5.82-16.8,5.89-24.25,2.41a15.25,15.25,0,0,1-5.79-4.66c-7.86-10.45,1.38-45,16.9-45C119,9.17,125,23.58,126.8,30.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_303",
    "data-name": 303,
    className: "cls-1",
    d: "M232.41,4.78c-4.61,3-5.64,8.87-6.66,19.86-1.5,16.09-2.2,24.18,0,26.54,6.54,7,24.78,4.57,31.53-5,10.2-14.38-7.21-43-19-43.28A10.87,10.87,0,0,0,232.41,4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_302",
    "data-name": 302,
    className: "cls-1",
    d: "M180.78,28.21C179,36.55,177.86,47.4,185,53.64c6.48,5.62,17,5.34,24.31,1.62,6.14-3.12,9-9.14,8.15-15.95C216.37,29.69,209.27,6,196.65,5.94,188.79,5.91,182.66,19.55,180.78,28.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_301",
    "data-name": 301,
    className: "cls-1",
    d: "M136.56,30.9C134.48,39.17,133,50,140,56.45c6.28,5.82,16.8,5.89,24.24,2.4A15.21,15.21,0,0,0,170,54.2c7.86-10.45-1.38-45-16.9-45.05C144.37,9.14,138.41,23.54,136.56,30.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "numbering"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(12.75 68.6)"
  }, "403"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(56.34 72.64)"
  }, "402"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(102.87 74.51)"
  }, "401"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(147.48 74.51)"
  }, "301"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(190.81 72.18)"
  }, "302"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(235.23 68.6)"
  }, "303"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatLowerIncisors);
export default __webpack_public_path__ + "static/media/cat_lower_incisors.21cfbca8fd92c4be32b2202032aef871.svg";
export { ForwardRef as ReactComponent };